import React from 'react';
import { Link } from '@reach/router';

const footer = () => (
    <footer className="footer-light">
        <div className="container">
            <div className="row">
                <div className="col-md-3 col-sm-6 col-xs-1">
                    <div className="widget">
                        <h5>Marketplace</h5>
                        <ul>
                            <li><Link to="/gallery">All NFTs</Link></li>
                            <li><Link to="/all-collections">All Collections</Link></li>
                        </ul>
                    </div>
                </div>
                <div className="col-md-3 col-sm-6 col-xs-1">
                    <div className="widget">
                        <h5>Community</h5>
                        <ul>
                            <li><a target="_blank" href="https://www.discord.gg/hodl4gold">Discord</a></li>
                            <li><a target="_blank" href="https://t.me/H4G_Official_Chat">Telegram</a></li>
                            <li><a target="_blank" href="https://twitter.com/hodl4gold">Twitter</a></li>
                            <li><a target="_blank" href="https://www.reddit.com/r/Hodl4Gold/">Reddit</a></li>
                        </ul>
                    </div>
                </div>
                <div className="col-md-3 col-sm-6 col-xs-1">
                    <div className="widget">
                        <h5>Resources</h5>
                        <ul>
                            <li><a target="_blank" href="https://hodl4gold.com">Hodl4Gold.com</a></li>
                            <li><a target="_blank" href="https://pancakeswap.finance/swap?outputCurrency=0xE8c4bEce93084D649fB630886b5332942b643BB9">Buy H4G Token</a></li>
                        </ul>
                    </div>
                </div>
                <div className="col-md-3 col-sm-6 col-xs-1">
                    <div className="widget">
                        {/* <h5>Newsletter</h5>
                        <p>Signup for our newsletter to get the latest news in your inbox.</p>
                        <form action="#" className="row form-dark" id="form_subscribe" method="post" name="form_subscribe">
                            <div className="col text-center">
                                <input className="form-control" id="txt_subscribe" name="txt_subscribe" placeholder="enter your email" type="text" />
                                <Link to="" id="btn-subscribe">
                                    <i className="arrow_right bg-color-secondary"></i>
                                </Link>
                                <div className="clearfix"></div>
                            </div>
                        </form>
                        <div className="spacer-10"></div>
                        <small>Your email is safe with us. We don't spam.</small> */}
                    </div>
                </div>
            </div>
        </div>
        {/* <div className="subfooter">
            <div className="container">
                <div className="clearfix mb-0">
                    <div className="d-flex justify-content-center col-12 text-center">
                        <a href="https://www.rugfreecoins.com/" target="_blank" rel="noreferrer">
                            <span className="float-md-start d-block d-md-inline-block mt-25">
                                <b>Developed By </b>
                                <img className="fallback-logo" src='/img/rfc-logo.svg' alt="logo" height={'30px'} />
                                <b>RugfreeCoins</b>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div> */}
    </footer>
);
export default footer;